<div class="relative flex h-full -m-6 flex-col">

  <!-- Content area -->
  <div class="flex flex-auto flex-col items-center p-8 pb-6 sm:flex-row sm:items-start sm:pb-8">
    <!-- Icon -->
    <div
      class="flex h-10 w-10 flex-0 items-center justify-center rounded-full sm:mr-4 bg-amber-100 text-amber-500 dark:bg-amber-500 dark:text-amber-50">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
    </div>

    <!-- Title + message -->
    <div class="mt-4 flex flex-col items-center space-y-1 text-center sm:mt-0 sm:items-start sm:pr-8 sm:text-left">

      <!-- Dynamic Title -->
      <div class="text-xl font-medium leading-6">
        @if(step === 1){
        {{(data.planName === LicenseType.ENTERPRISE ? 'Enterprise Plan Setup' : 'Individual Plan Setup')}}
        }@else{
        Confirm Your Plan
        }
      </div>

      <!-- Step 1: Input or Info -->
      <div *ngIf="step === 1 && data.planName === LicenseType.ENTERPRISE" class="w-full mt-4 space-y-3">
        <div class="text-secondary">
          Please enter the number of users you’d like to include in your Enterprise plan.
        </div>

        <form [formGroup]="planForm" class="w-full">
          <label for="users" class="block text-sm font-medium text-gray-700 mb-1">Number of Users</label>
          <input id="users" type="number" formControlName="users" min="1" max="{{ maxUsers }}" step="1"
            inputmode="numeric" pattern="\d*"
            class="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-warn-400 no-spinner" />
          <div
            *ngIf="planForm.controls['users'].invalid && (planForm.controls['users'].dirty || planForm.controls['users'].touched)"
            class="text-red-500 text-sm mt-1">

            @if (planForm.controls['users'].errors?.['required']) {
            Number of users is required.
            }
            @else if (planForm.controls['users'].errors?.['min']) {
            Minimum 1 user is required.
            }
            @else if (planForm.controls['users'].errors?.['max']) {
            Maximum {{ maxUsers }} users allowed.
            }
            @else if (planForm.controls['users'].errors?.['pattern']) {
            Only positive integers are allowed.
            }

          </div>
        </form>
      </div>

      <!-- Step 2: Confirmation -->
      <div *ngIf="step === 2" class="text-secondary mt-4">
        <p class="mt-2 font-medium text-gray-700">
          @if(data.planName === LicenseType.ENTERPRISE){
          You’re about to sign up for the <strong>{{ data.planName | titlecase }}</strong> plan for <strong>{{ userCount
            }}</strong> user{{ userCount > 1 ? 's' : '' }}.
          }@else{
          You’re about to sign up for the <strong>{{ data.planName | titlecase }}</strong> plan.
          }
        </p>
        <p class="font-medium text-gray-700">
          Are you sure you want to proceed?
        </p>
      </div>
    </div>
  </div>


  <div
    class="flex items-center justify-center space-x-3 bg-gray-50 px-6 py-4 dark:bg-black dark:bg-opacity-10 sm:justify-end">

    <!-- Cancel -->
    @if(step ===1){

    <button mat-stroked-button (click)="closeDialog()">
      Cancel
    </button>

    <button mat-flat-button color="primary" (click)="nextStep()">
      Next
    </button>
    }@else {
    @if(data.planName === LicenseType.INDIVIDUAL){
    <button mat-stroked-button (click)="closeDialog()">
      Cancel
    </button>
    }@else{
    <button mat-stroked-button (click)="previousStep()" *ngIf="data.planName === LicenseType.ENTERPRISE">
      Back
    </button>
    }


    <button mat-flat-button color="primary" (click)="confirmPlan()">
      Confirm
    </button>
    }

  </div>

</div>